import type { DecimalString, RoomItemState, Uuid } from './subprojects';

export type { DecimalString, Uuid } from './subprojects';

export type ProjectStatus =
  | 'planificacion'
  | 'en_progreso'
  | 'presupuestado'
  | 'finalizado';

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  planificacion: 'Planificación',
  en_progreso: 'En progreso',
  presupuestado: 'Presupuestado',
  finalizado: 'Finalizado',
};

export function formatProjectStatus(status: ProjectStatus | string): string {
  return PROJECT_STATUS_LABELS[status as ProjectStatus] ?? status;
}

type NullableDecimalString = DecimalString | null;

export interface ProjectSummary {
  subprojects_count: number;
  rooms_count: number;
  surface_total_m2: DecimalString;
  planned_budget_total: DecimalString;
  actual_budget_total: NullableDecimalString;
  actual_cost_total: NullableDecimalString;
  planned_margin_avg: NullableDecimalString;
  real_margin_avg: NullableDecimalString;
}

export interface ProjectBase {
  id: Uuid;
  ref: string;
  name: string;
  type: string;
  client: string;
  address: string;
  status: ProjectStatus;
  total_budget: DecimalString;
  created_at: string;
}

export interface ProjectDetail extends ProjectBase {
  summary: ProjectSummary;
}

export interface ProjectSubproject {
  id: Uuid;
  project_id: Uuid;
  ref: string | null;
  name: string;
  type: string;
  status: ProjectStatus;
  rooms_count: number;
  planned_budget: DecimalString;
  actual_budget: NullableDecimalString;
  actual_cost: NullableDecimalString;
  surface_m2: DecimalString;
  progress_pct: number;
  created_at: string;
}

export interface ProjectSubprojectCreatePayload {
  name: string;
  type: string;
  surface_m2: DecimalString;
  planned_budget: DecimalString;
  rooms_count: number;
  status?: ProjectStatus;
}

export interface ProjectItem {
  id: Uuid;
  subproject_id: Uuid;
  subproject_name: string;
  room_id: Uuid;
  room_name: string;
  ref: string;
  supplier: string;
  description: string;
  category: string | null;
  quantity: number;
  discount: DecimalString;
  unit_cost: DecimalString;
  pvp: DecimalString;
  net_total_pvp: DecimalString;
  net_unit_pvp: DecimalString;
  real_cost_total: DecimalString;
  mounting: NullableDecimalString;
  state: RoomItemState;
  created_at: string;
}

export interface ProjectFinance {
  total_cost: DecimalString;
  total_mounting: DecimalString;
  total_extras: DecimalString;
  total_pvp: DecimalString;
  gross_margin_amount: DecimalString;
  gross_margin_pct: NullableDecimalString;
  iva_amount: DecimalString;
  total_with_iva: DecimalString;
  budget_difference: DecimalString;
  estimated_margin_pct: NullableDecimalString;
  real_margin_pct: NullableDecimalString;
}
